(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-open-discussion"]) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('.rc-discussion__form').forEach((form) => {
      if (form.dataset.rcReady) return;
      form.dataset.rcReady = 'true';
      const button = form.querySelector('button[type="submit"]');
      const label = form.querySelector('.rc-discussion__submit-label');
      const sending = form.querySelector('.rc-discussion__sending-label');
      const reset = () => {
        delete form.dataset.rcSubmitting;
        form.removeAttribute('aria-busy');
        if (button) button.disabled = false;
        if (label) label.hidden = false;
        if (sending) sending.hidden = true;
      };
      form.querySelectorAll('[data-empty-message]').forEach((field) => {
        const validate = () => field.setCustomValidity(field.value.trim() ? '' : field.dataset.emptyMessage);
        field.addEventListener('input', validate);
        field.addEventListener('change', validate);
      });
      form.addEventListener('submit', (event) => {
        if (form.dataset.rcSubmitting === 'true') {
          event.preventDefault();
          return;
        }
        if (!form.checkValidity()) return;
        queueMicrotask(() => {
          if (event.defaultPrevented) return;
          form.dataset.rcSubmitting = 'true';
          form.setAttribute('aria-busy', 'true');
          if (button) button.disabled = true;
          if (label) label.hidden = true;
          if (sending) sending.hidden = false;
        });
      });
      window.addEventListener('pageshow', reset);
      form.querySelector('[data-rc-result]')?.focus();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-product-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-rcs-review-carousel]').forEach((carousel) => {
      const badge = document.querySelector('[data-review-badge="' + carousel.dataset.reviewProduct + '"]');
      const summary = carousel.querySelector('[data-review-summary]');
      if (badge && summary) badge.textContent = summary.textContent.trim();
      if (carousel.dataset.rcprReady === 'true') return;
      carousel.dataset.rcprReady = 'true';
      if (badge) badge.closest('a').addEventListener('click', (event) => {
        event.preventDefault();
        carousel.scrollIntoView({ behavior: 'instant', block: 'start' });
        const heading = carousel.querySelector('h2');
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      });
      const track = carousel.querySelector('[data-rcpr-track]');
      carousel.querySelectorAll('[data-rcpr-direction]').forEach((button) => {
        button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.rcprDirection) * track.clientWidth * 0.85, behavior: 'smooth' }));
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
